export default __webpack_public_path__ + "static/subset-UniNeueHeavy-8ecb530658c7802a74deeb263ea5b800.woff";